
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAbstractPoiObject as ObcAbstractPoiObjectElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-object/abstract-poi-object.js';
 
 
 

 
 export const ObcAbstractPoiObject = createComponent({
   react: React,
   tagName: 'undefined',
   elementClass: ObcAbstractPoiObjectElement,
   events: {
     
   }
  });
 
 